import './common.css';

export const Modal = ({ isOpen, onClose, title, children, footer }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 className="modal-title">{title}</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">{children}</div>
                {footer && <div className="modal-footer">{footer}</div>}
            </div>
        </div>
    );
};

export const Button = ({ children, variant = 'primary', size = 'md', ...props }) => {
    const className = `btn btn-${variant} ${size === 'sm' ? 'btn-sm' : ''}`;
    return <button className={className} {...props}>{children}</button>;
};

export const Card = ({ children, className = '' }) => {
    return <div className={`card ${className}`}>{children}</div>;
};
